import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { Button, Card, Col, Row } from "reactstrap";
import './landing-cards.scss';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const LandingCards = ({eventPosts, showTitle}: any) => {
  let colSize = 4;
  if (eventPosts.length === 1){
    const node = eventPosts[0];
    const details = node.details;    
    return (
      <Row>
        {node?.internalLink &&
          <Col md="7">
            <Link to={node?.internalLink}>
              <GatsbyImage image={node.displayImage.gatsbyImageData} alt={node.title} className="fluid"></GatsbyImage>
            </Link>
        </Col>
        }
        {!node?.internalLink && node?.externalLink &&
          <Col md="7">
            <Link to={node?.externalLink}>
              <GatsbyImage image={node.displayImage.gatsbyImageData} alt={node.title} className="fluid"></GatsbyImage>
            </Link>
          </Col>
        }
        {!node?.internalLink && !node?.externalLink &&
        <Col md="7">
          <Link to={node.fields.slug}>
            <GatsbyImage image={node.displayImage.gatsbyImageData} alt={node.title} className="fluid"></GatsbyImage>
          </Link>
        </Col>
        }
        <Col md="5">
          <h2>{node.title}</h2>
          <Row>
            {details.raw && documentToReactComponents(JSON.parse(details.raw))}
          </Row>
          {node?.externalLink && 
            <Row>
              <a href={node?.externalLink.externalLink} target="_blank">
                {node?.title}
              </a>
            </Row>
          }
          {node?.internalLink && 
            <Row>
              <Link to={node?.internalLink} className="page-event-link">          
                <Button variant="Link" size="md" className="learn-more-btn">Learn More</Button>
              </Link> 
            </Row>
          }
        </Col>
      </Row>
    )
  }
  else if (eventPosts.length === 2){
    colSize = 6;
    return (
      <Row>
        {eventPosts.map((node: any) => (
          <Col md={colSize} sm={12} className="event-col" key={node.title}>
            <div className="d-sm-block d-none text-center">
              {displayLinkedImage(node)}
            </div>
            <div className="d-block d-sm-none">
              {displayLinkedImage(node)}
            </div>
          </Col>
        ))}
      </Row>
    )
  }
  else if (eventPosts.length > 2){
    colSize = 4;
    return(
      <Row>
        {eventPosts.map((node: any) => (
          <Col md={colSize} sm={12} className="event-col" key={node.title}>
            <div className="d-sm-block d-none text-center">
              {displayLinkedImage(node)}
            </div>
            <div className="d-block d-sm-none">
              {displayLinkedImage(node)}
            </div>
          </Col>
        ))}
      </Row>
    )
  }
  else 
    return (
      <><h2>No Events in this section.</h2></>
    )
  
  function displayLinkedImage(node: any){
    let imageToDisplay = node.displayImage.gatsbyImageData;
    if (node?.linkOnly){
      let imageLink = node?.internalLink ?? node?.externalLink?.externalLink ?? node?.fields?.slug ?? '';

      return(
        <Link to={imageLink} className="landing-event-image">          
          <GatsbyImage image={imageToDisplay} alt={node.title} className="landing-event-image fluid mx-auto"></GatsbyImage>
          {showTitle && <Button variant="Link" size="lg" className="btn-img-title">{node?.title}</Button>}
        </Link> );
    }
    else{
      imageToDisplay = node?.pageImage?.gatsbyImageData ?? node?.displayImage?.gatsbyImageData;
      return(
        <Link to={node?.fields?.slug} className="landing-event-image">          
          <GatsbyImage image={imageToDisplay} alt={node.title} className="landing-event-image fluid mx-auto"></GatsbyImage>
          {showTitle && <Button variant="Link" size="lg" className="btn-img-title">{node?.title}</Button>}
        </Link> 
      )
    }
  }
}

export default LandingCards;
